module.exports = __webpack_public_path__ + "img/developpement-lazy.700e6e74.jpg";